export default "__VITE_ASSET__DWtnAXp___"